import { Link } from 'react-router-dom';
import { trackNavClick } from '../utils/analytics';
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="px-6 py-12 border-t border-border bg-gradient-to-br from-surface via-bg to-accent-light/20">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-2">
              <h3
                className="text-2xl font-heading font-bold"
                style={{
                  background: 'linear-gradient(90deg, #06b6d4 0%, #10b981 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  MozBackgroundClip: 'text',
                  MozTextFillColor: 'transparent',
                  display: 'inline-block',
                }}
              >
                Debt Chisel
              </h3>
            </div>
            <p className="text-sm text-muted max-w-sm leading-relaxed">
              Smart debt payoff plans for variable income earners. Stop guessing, start chipping
              away.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-semibold mb-3 text-fg">Product</h4>
            <ul className="space-y-2 text-sm text-muted">
              <li>
                <a
                  href="#features"
                  className="hover:text-accent transition-colors cursor-pointer"
                  onClick={() => trackNavClick('Features', '#features')}
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="#pricing"
                  className="hover:text-accent transition-colors cursor-pointer"
                  onClick={() => trackNavClick('Pricing', '#pricing')}
                >
                  Pricing
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  className="hover:text-accent transition-colors cursor-pointer"
                  onClick={() => trackNavClick('FAQ', '#faq')}
                >
                  FAQ
                </a>
              </li>
              <li>
                <a
                  href="https://app.debtchisel.com/register"
                  className="hover:text-accent transition-colors cursor-pointer"
                  onClick={() => trackNavClick('Sign Up', 'https://app.debtchisel.com/register')}
                >
                  Sign Up
                </a>
              </li>
              <li>
                <a
                  href="https://app.debtchisel.com/login"
                  className="hover:text-accent transition-colors cursor-pointer"
                  onClick={() => trackNavClick('Log In', 'https://app.debtchisel.com/login')}
                >
                  Log In
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-3 text-fg">Legal</h4>
            <ul className="space-y-2 text-sm text-muted">
              <li>
                <Link
                  to="/privacy"
                  className="hover:text-accent transition-colors cursor-pointer"
                  onClick={() => trackNavClick('Privacy', '/privacy')}
                >
                  Privacy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="hover:text-accent transition-colors cursor-pointer"
                  onClick={() => trackNavClick('Terms of Service', '/terms')}
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border flex items-center justify-center">
          <p className="text-sm text-muted">© {currentYear} Debt Chisel. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
